import {PAGES} from '../../core/route/routeConstants';

export const PAGES_WITH_SPECIAL_FOOTER = [
  PAGES.CATEGORY_PAGE,
  PAGES.HURLY_CATEGORY_PAGE,
  PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU,
  PAGES.PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID,
]
